import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getSubscriptionsList() {
  return axios.get(API_URL+'/v1/suscription/all')
}
export function getSubscriptionsListglobal(tenant:number) {
  return axios.get(API_URL+'/v1/suscription/all?tenantId='+tenant)
}
export function getFeaturesDisponibles() {
  return axios.get(API_URL+'/v1/features')
}
export function getFeaturesDisponiblesGlobal() {
  return axios.get(API_URL+'/v1/features')
}
export function getFeatureId(id:any) {
    return axios.get(API_URL+'/v1/features/'+id)
  }
export function getFeatureIdGlobal(id:any,tenant:number) {
    return axios.get(API_URL+'/v1/features/'+id+'?tenantId='+tenant)
  }
export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }